import React from 'react';
import { useQuery } from '@apollo/client';
import { useFormContext } from 'react-hook-form';
import { AutocompleteField } from 'components/form';
import { Country } from '@trnsact/trnsact-shared-types';

import { DealSheetRulesFilters } from './index';
import { dealSheetConfigurationApi } from '../../../../api';

export const State = () => {
  const { control } = useFormContext<DealSheetRulesFilters>();

  const { data: usRegionsResponse, loading: usRegionsLoading } = useQuery(dealSheetConfigurationApi.getRegions, {
    variables: { input: { country: Country.Us } },
  });

  const usRegions = usRegionsResponse?.dealSheets?.result?.list ?? [];

  return (
    <AutocompleteField
      multiple
      size="small"
      name="STATE"
      control={control}
      options={usRegions}
      disableCloseOnSelect
      loading={usRegionsLoading}
      textFieldProps={{ variant: 'outlined', label: 'State' }}
    />
  );
};
